import React from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { BeeGlyph } from '@/components/brand/mm-logo';
import { useQbee } from './qbee-context';

/**
 * The ways into Qbee from a page: the header's "Ask Qbee" (opens the dock on
 * this page's suggestions) and a section's "Explain" (asks about that
 * section, so the answer starts from what is on screen). Both render nothing
 * outside the app shell, where there is no dock.
 */

export function AskQbeeChip({ className }) {
  const q = useQbee();
  if (!q) return null;
  return (
    <button type="button" onClick={q.openDock} title="Ask Qbee about this page"
      className={cn('inline-flex h-7 items-center gap-1.5 rounded-full border border-border bg-card px-2.5 text-[12.5px] font-medium text-muted-foreground transition-colors hover:border-primary/50 hover:text-foreground print:hidden', className)}>
      <BeeGlyph size={14} animate={false} /> Ask Qbee
    </button>
  );
}

export function ExplainButton({ title, className }) {
  const q = useQbee();
  if (!q || typeof title !== 'string' || !title.trim()) return null;
  return (
    <button type="button" title={`Explain "${title}" with Qbee`} aria-label={`Explain ${title} with Qbee`}
      onClick={(e) => { e.stopPropagation(); q.ask(`Explain "${title}" on this page: what it shows and how to read it.`, { section: title }); }}
      className={cn('inline-grid size-6 shrink-0 place-items-center rounded-md align-middle text-muted-foreground/70 transition-colors hover:bg-primary/10 hover:text-primary print:hidden', className)}>
      <Sparkles className="size-3.5" />
    </button>
  );
}
